import { apiClient, buildQuery } from '~/api/client'
import type {
    AdminMaintenanceEvent,
    AdminMaintenanceEventDetail,
} from '~/api/types'

// 유지하기 읽기 API. 유지하기 "데이터" 탭에서 변경 이벤트 목록·상세를 소비한다.

export interface ListMaintenanceEventsParams {
    q?: string
    limit?: number
    offset?: number
}

/** GET /admin/api/services/maintenance/events — 변경 이벤트 목록(페이지네이션). */
export function listMaintenanceEvents(
    params: ListMaintenanceEventsParams = {}
) {
    const query = buildQuery({
        q: params.q,
        limit: params.limit,
        offset: params.offset,
    })
    return apiClient.get<AdminMaintenanceEvent[]>(
        `/services/maintenance/events${query}`
    )
}

/** GET /admin/api/services/maintenance/events/{id} — 변경 이벤트 상세. */
export function getMaintenanceEvent(id: string) {
    return apiClient.get<AdminMaintenanceEventDetail>(
        `/services/maintenance/events/${id}`
    )
}
